(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/card-puff-video/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_layouts/card-puff-video/assets/javascripts/init.js');

'use strict';

svs.banner_layouts.card_puff_video.init = (() => {
  const checkIframeAndHideLabel = e => {
    if (e && e.data) {
      try {
        const data = JSON.parse(e.data);
        if (data.func === 'metadata') {
          const videoEl = document.querySelector("[data-videoid='".concat(data.id, "']"));
          videoEl.closest('.banner-card-puff-video').classList.add('banner-card-label-hidden');
        }
      } catch (error) {
      }
    }
  };
  const clickHandler = e => {
    if (e && e.target) {
      try {
        const videoEl = e.target;
        videoEl.closest('.banner-card-puff-video').classList.add('banner-card-label-hidden');
      } catch (error) {
      }
    }
  };
  const playerElements = document.querySelectorAll('.js-youtube-video-player');
  playerElements.forEach(element => element.addEventListener('click', clickHandler, true));
  window.addEventListener('message', checkIframeAndHideLabel, false);
})();

 })(window);